import { Awards } from '../../api';

export const getAwardQuery = (id: number) => ({
  queryKey: ['awards', id],
  queryFn: async () => Awards.getAward(id),
});
